var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGridFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 6.66667V9.33333H6.66667V6.66667H9.33333ZM10.6667 6.66667H14V9.33333H10.6667V6.66667ZM9.33333 14H6.66667V10.6667H9.33333V14ZM10.6667 14V10.6667H14V13.3333C14 13.7015 13.7015 14 13.3333 14H10.6667ZM9.33333 2V5.33333H6.66667V2H9.33333ZM10.6667 2H13.3333C13.7015 2 14 2.29848 14 2.66667V5.33333H10.6667V2ZM5.33333 6.66667V9.33333H2V6.66667H5.33333ZM5.33333 14H2.66667C2.29848 14 2 13.7015 2 13.3333V10.6667H5.33333V14ZM5.33333 2V5.33333H2V2.66667C2 2.29848 2.29848 2 2.66667 2H5.33333Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGridFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grid-fill.5015c0d6.svg";
export { ForwardRef as ReactComponent };